import { Flex, Tabs, TabsProps, ConfigProvider } from "antd";
import Title from "antd/es/typography/Title";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OrderList from "./components/OrderList";
import { MemberContext } from "../../../context/MemberProvider.tsx";
import { orderType } from "../../../types/order.ts";

const Order: React.FC = () => {
  const [currentTab, setCurrentTab] = useState("1");
  const { t } = useTranslation();
  const { memberData, platform } = useContext(MemberContext);

  const [inProgressData, setInProgressData] = useState<orderType[]>([]);
  const [completedData, setCompletedData] = useState<orderType[]>([]);

  const foregroundColorAlpha = (): string => {
    return memberData?.foreground_color + "B3"; // B3 is 70% opacity
  };
  useEffect(() => {
    if (!memberData) {
      return;
    }
    const inProgress =
      memberData.card_orders
        ?.filter((order) => order.tab_status === "In progress")
        .slice(0, 100) || [];
    const completed =
      memberData.card_orders
        ?.filter((order) => order.tab_status === "Completed")
        .slice(0, 100) || [];
    setInProgressData(inProgress);
    setCompletedData(completed);
  }, [memberData]);

  const contents = () => {
    if (!memberData) {
      return null;
    }


    const items: TabsProps["items"] = [
      {
        key: "1",
        label: t("In progress"),
        children: (
          <OrderList
            data={inProgressData}
            orderURL={memberData.order_url}
            showStatus={true}
          />
        ),
      },
      {
        key: "2",
        label: t("Completed"),
        children: (
          <OrderList
            data={completedData}
            orderURL={memberData.order_url}
            showStatus={true}
            completed
          />
        ),
      },
    ];


    // TO OPTIMIZE: consider using api to get the status
    const useTabs = platform !== "flaps";

    return useTabs ? (
      <>
        <Tabs
          defaultActiveKey="1"
          items={items}
          centered
          activeKey={currentTab}
          className="w-full"
          tabBarStyle={{ color: memberData.foreground_color }}
          onChange={(e) => setCurrentTab(e)}
        />
      </>
    ) : (
      <>
        <OrderList
          data={completedData}
          orderURL={memberData.order_url}
          showStatus={false}
        />
      </>
    );
  };

  return (
    memberData && (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: memberData.foreground_color,
            colorPrimaryHover: memberData.foreground_color + "B4",
          },

          components: {
            Tabs: {
              itemColor: "#8C9CAB",
              itemHoverColor: foregroundColorAlpha(),
            },
          },
        }}
      >
        <Flex data-testid="order" vertical className="w-full min-h-[85vh]">
          <Title
            level={2}
            style={{
              paddingTop: "12px 16px 0 16px",
              position: "sticky",
              top: 0,
              zIndex: "10",
            }}
            className="h2-bold bg-white p-4"
          >
            {t("My orders")}
          </Title>
          {contents()}
        </Flex>
      </ConfigProvider>
    )
  );
};
export default Order;
